var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"privacy","name":"termly-embed","data-id":"5b548a33-8e9b-45e0-9b3f-5e472a871dfa","data-type":"iframe"}})}
var staticRenderFns = []

export { render, staticRenderFns }